import React from 'react';
import { Field, useFormikContext } from 'formik';
import { defineMessages, useIntl } from 'react-intl';
import { InputNumberComponent } from '../../../components/prime-formik';

const i18n = defineMessages({
  ccInterestsMinimumMatchPercentage: {
    id: 'report.match-percentage.cc-interests-minimum',
    defaultMessage: 'Career Counselling - Interests Report minimum match percentage',
  },
  ccPersonalityMinimumMatchPercentage: {
    id: 'report.match-percentage.cc-personality-minimum',
    defaultMessage: 'Career Counselling - Personality Report minimum match percentage',
  },
});

const SuperLinkFormMinimumMatchPercentageInputGroup = () => {
  const { formatMessage } = useIntl();
  const { setFieldValue } = useFormikContext();

  return (
    <div className="super-link-minimum-match-percentage-input-group">
      <div className="super-link-minimum-match-percentage-label">
        {formatMessage(i18n.ccInterestsMinimumMatchPercentage)}
      </div>
      <div className="p-grid">
        <div className="p-col-2">
          <Field
            id="ccInterestsMinimumMatchPercentage"
            name="ccInterestsMinimumMatchPercentage"
            component={InputNumberComponent}
            setFieldValue={setFieldValue}
          />
        </div>
      </div>
      <div className="super-link-minimum-match-percentage-label">
        {formatMessage(i18n.ccPersonalityMinimumMatchPercentage)}
      </div>
      <div className="p-grid">
        <div className="p-col-2">
          <Field
            id="ccPersonalityMinimumMatchPercentage"
            name="ccPersonalityMinimumMatchPercentage"
            component={InputNumberComponent}
            setFieldValue={setFieldValue}
          />
        </div>
      </div>
    </div>
  );
};

export default SuperLinkFormMinimumMatchPercentageInputGroup;
